export const SERVER_SGCM_API_ORIGIN = process.env.SGCM_API_ORIGIN;
export const SERVER_SGCM_MARKETPLACE_API_ORIGIN = process.env.SGCM_MARKETPLACE_API_ORIGIN; // @suppress longLineCheck
